import React, { useState } from "react";
import { useMutation } from "@apollo/client";
import {
  useMyOrgInfo,
  useUserInfo,
} from "../../../../Layout/AppMain/LoginStatusContext";
import TextareaAutosize from "react-textarea-autosize";
import { Card, Button } from "reactstrap";
import { UPDATE_PURPOSE } from "../../../../queries";
import * as Ionicons from "react-icons/io";

const MissionCard = (obj) => {
  const myOrgInfo = useMyOrgInfo();
  const myPage = myOrgInfo.id == obj.obj.id;
  const { ability } = useUserInfo();
  const [purpose, setPurpose] = useState(obj.obj.purpose);
  const [editAble, setEditAble] = useState(false);
  const buttonToggle = () => setEditAble(!editAble);
  const SettingIcon = Ionicons["IoIosSettings"];
  const SyncIcon = Ionicons["IoIosSync"];
  const [editPurpose, { data }] = useMutation(UPDATE_PURPOSE, {
    variables: 1,
  });

  const editidPurpose = async (e) => {
    try {
      await editPurpose({
        variables: { orgId: obj.obj.id, purpose: purpose },
      });
      buttonToggle();
    } catch (err) {
      alert(err.message);
    }
  };

  const CloseIcon = Ionicons["IoIosClose"];

  return (
    <Card className="mb-2  org_contentarea">
      <div className="org_subtitle_sec">
        <h4 className="org_subtitle">事業概要（ミッション）</h4>
        {myPage && ability == "can_edit" ? (
          editAble ? (
            <>
              <Button onClick={editidPurpose} className="ema__btn__update">
                <SyncIcon fontSize="17px" />
                <span className="pl-2">更新</span>
              </Button>
              {/* <CloseIcon fontSize="17px" onClick={(e) => buttonToggle} /> */}
            </>
          ) : (
            <>
              <Button onClick={buttonToggle} className="ema__btn__edit">
                <SettingIcon fontSize="20px" />
                <span className="pl-2">情報の編集</span>
              </Button>
            </>
          )
        ) : (
          <></>
        )}
      </div>
      {editAble ? (
        <div className="org_item">
          <p className="org_text">
            <TextareaAutosize
              className="form-control"
              placeholder="ミッション、ビジョン、バリュー、事業概要（組織が取り組む社会課題の概要とアプローチ方法など）"
              minRows={3}
              maxRows={6}
              defaultValue={purpose}
              value={purpose}
              onChange={(e) => setPurpose(e.target.value)}
            />
          </p>
        </div>
      ) : (
        <div className="org_item">
          <p className="org_text" style={{ whiteSpace: "pre-wrap" }}>
            {purpose}
          </p>
        </div>
      )}
    </Card>
  );
};

export default MissionCard;
